export default [
  /**
   * 隐私协议
   * type
   * title
   */
  {path: "/news/ysxy", component: () => import('../page/news/ysxy')},
  {path: "/news/detail/:newsId", component: () => import('../page/news/detail')},
  /**
   * 新闻列表
   * @query.id
   */
  {path: "/news/list", component: () => import('../page/news/list')}
]



// WEBPACK FOOTER //
// ./src/router/news.js